<smrts-dialog [title]="titulo" [hasFootnote]="true">

  @if (modoBuscaEmMassa) {
    <div class="origem-destino">
      <label>Origem da busca</label>
      <mat-button-toggle-group [(ngModel)]="origemBuscaEmMassa">
        <mat-button-toggle [value]="origemBanco">{{ tipoBancoNome }}</mat-button-toggle>
        <mat-button-toggle [value]="origemCaixa">Caixa</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }

  @if (modoBuscaEmMassa) {
    <div class="info-banner">
      Filtros da busca em massa
    </div>
  }

  <div class="custom-table">
    <div class="custom-table-row">
      <p-selectButton
        [options]="opcoesModoBusca"
        [(ngModel)]="modoBusca"
        (onChange)="onModoBuscaChange($event.value)"
        optionLabel="label"
        optionValue="value">
      </p-selectButton>
    </div>
    <div class="custom-table-row">
      <div class="custom-table-col">
        <p-floatlabel variant="on" class="full-width">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body" [(ngModel)]="dataInicioBusca" [disabled]="isDisabledDataInicio()" fluid />
          <label>Data inicio da busca</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col">
        <p-floatlabel variant="on" class="full-width">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body" [(ngModel)]="dataFimBusca" [disabled]="isDisabledDataFim()" fluid />
          <label>Data fim da busca</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="custom-table-row">
      <div class="custom-table-col">
        <p-floatlabel variant="on" class="full-width">
          <p-inputnumber inputId="profundidadeBusca" [(ngModel)]="profundidadeBusca" fluid [useGrouping]="false" [min]="0" />
          <label for="profundidadeBusca">Profundidade Máxima</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col">
        <p-floatlabel variant="on" class="full-width">
          <p-inputnumber inputId="tempoLimiteBusca" [(ngModel)]="tempoLimiteBusca" fluid [useGrouping]="false" [min]="0" />
          <label for="tempoLimiteBusca">Tempo limite da Busca (s)</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="custom-table-row">
      <mat-checkbox [(ngModel)]="buscarSubtabelas">{{ labelBuscarSubtabelas }}</mat-checkbox>
    </div>
  </div>


  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button [mat-dialog-close]="true" (click)="aplicarClick()">
      {{ textoBotaoAplicar }}
    </button>
  </div>
</smrts-dialog>
